module.exports = __webpack_public_path__ + "static/index/img/baikal-101.0fcb52a3.jpg";